import $ from 'jquery';

class MultiPrint {
	
	constructor() {

		$(".multi-print").each((i, element) => {
			if ($(element).hasClass("initialized")) {
				return;
			}
			$(element).click(e => {
				e.preventDefault();
				let type = $(element).data("type");
                let ids = $(element).data("ids");
                let name = $(element).data("name");


				this.modal({
					type: type,
					ids: ids,
					name: name
				});

			}).addClass("initialized");

		});

	}

	modal(data) {
		let div = $("<div></div>").addClass("modal fade");
		let dialog = $("<div></div>").addClass("modal-dialog");
		let contents = $("<div></div>").addClass("modal-content");
		let header = $("<div></div>").addClass("modal-header").html(
			'<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>'
			).append(
			$("<h4></h4>").html("Download Multiple Documents PDF").addClass("modal-title")
			);
		let body = $("<div></div>").addClass("modal-body").html($("<p></p>").html("Your PDF is being prepared. Please wait..."));

		$(body).append($("<img>").attr("src", "/img/loader.gif").css({margin: "auto", display: "block"}));

    let perc = $("<div></div>").attr("id", "multipdf_perc");
    $(body).append(perc);



    let footer = $("<div></div>").addClass("modal-footer").hide();

		let cancel = $('<button type="button" class="btn btn-default">Close</button>');

		$(cancel).click(e => {
			e.preventDefault();
			$(div).modal('hide');
		});


		$(footer).html(cancel);

		$(contents).html(header).append(body).append(footer);

		$(dialog).html(contents);
		$(div).html(dialog);


		$("body").append(div);


		$(div).on('hidden.bs.modal', function (e) {
		  $(div).remove();
		});

		$(div).modal('show');


        $.ajax({
            data:{
                op: "multiPDF",
                data: data
            },
            success: result => {
            	let obj = {id: 0};
                obj.id = setInterval(() => {
                	this.poll(result.id, div, obj);
				}, 1000);
            }
        });

	}

	poll(id, div, obj) {
        $.ajax({
            data:{
                op: "getPDF",
                id: id
            },
            success: result => {
                if (result.status == "ready") {
                	window.location = result.url;
                    $(div).modal('hide');
                    clearInterval(obj.id);
                }
                if (result.status == "failed") {

                            clearInterval(obj.id);
                  let body = $(div).find(".modal-body");
                  $(body).html($("<p></p>").html("Oops!! Something wrong happened"));

                            $(body).append($("<img>").attr("src", "/img/error.png").css({margin: "auto", display: "block"}));


                            $(body).append($("<p></p>").html(result.error).addClass("alert alert-danger"));

                            $(div).find(".modal-footer").show();
                }
                if (result.status === "processing") {
                  $("#multipdf_perc").html(`${result.data.completed} out of ${result.data.total} completed`);
                }
            }
        });
	}

}

export default MultiPrint;
